import * as React from 'react';
import { Typography, Container, Grid, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import { SectionContainer, FeatureCard, CardTitle } from './Components/styles';
import ScrollAnimation from './Components/ScrollAnimation';

const whyUsData = [
    {
        title: "AI Post Generators",
        description: "Write attention-grabbing and engaging posts within seconds with our AI post generators.",
    },
    {
        title: "Preview Your Posts",
        description: "See how your LinkedIn posts will look before you publish them.",
    },
    {
        title: "Images & Videos",
        description: "You can post videos, GIFs, multiple images, and single images with Postdrips.",
    },
    {
        title: "Post Styling",
        description: "Add styling to your posts with bold, italic and more.",
    },
    {
        title: "Post Scheduling",
        description: "Schedule your posts to be published at your preferred time.",
    },
    {
        title: "Viral Post Database",
        description: "Access a database of viral posts to get inspiration for your own posts.",
    },
    {
        title: "Linkedin Carousel",
        description: "Create and edit LinkedIn carousels with ease.",
    },
    {
        title: "Post Strength & Readability",
        description: "Check the strength and readability of your posts.",
    },
    {
        title: "Manage Multiple Accounts",
        description: "Manage multiple LinkedIn accounts from a single dashboard.",
    },
    {
        title: "Content Branding",
        description: "Customize your posts to match your brand's voice and writing style.",
    },
    {
        title: "Multilingual Posts",
        description: "Generate posts in multiple languages",
    },
    {
        title: "Chat with your posts",
        description: "Chat with your posts and get insights on how to improve them.",
    }
];

export default function SneakPeak() {

    return (
        <div id="features">
            <Container maxWidth="lg" sx={{ mt: 3, mb: 6 }}>
                <SectionContainer>
                    <ScrollAnimation animateIn="fadeInRight" delay={0.2}>
                        <Typography variant="h3" sx={{ fontSize: '44px', color: '#000135', fontWeight: 700, lineHeight: 1.13, letterSpacing: '-1.76px', mb: 8 }}>
                            What you get with Scriptu
                        </Typography>
                    </ScrollAnimation>

                    <Grid container spacing={4} >
                        {whyUsData.map((item, index) => (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                                <ScrollAnimation animateIn="fadeInLeft" delay={0.2}>
                                    <motion.div
                                        whileHover={{ scale: 1.15 }}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        <FeatureCard>
                                            <CardContent sx={{ minHeight: '110px' }}>
                                                <CardTitle sx={{ color: '#1B2A52', textAlign: 'left' }}>{item.title}</CardTitle>
                                                <Typography color="#6A738B" sx={{ fontSize: '14px', fontWeight: '400', lineHeight: '22px', textAlign: 'left' }}>
                                                    {item.description}
                                                </Typography>
                                            </CardContent>
                                        </FeatureCard>
                                    </motion.div>
                                </ScrollAnimation>
                            </Grid>
                        ))}
                    </Grid>
                </SectionContainer>
            </Container>
        </div >
    );
}
